/* src/app/account/digital-wallet/dw-rewardship/dw-rewardship-advanced-filter-chips/chip/dw-rewardship-advanced-filter-chip.component.scss */
.chip {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  column-gap: 0.25rem;
  background-color: #FEF6CC;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 0.9rem;
}
.chip .close-icon {
  width: 1rem;
  height: 1rem;
  font-size: 1rem;
  cursor: pointer;
}
/*# sourceMappingURL=dw-rewardship-advanced-filter-chip.component.css.map */
